<template>
  <vs-tabs style="z-index: 2;" alignment="center">
    <vs-tab icon="account_circle" label="Minhas Pré-Matrículas">
      <MyPreRegistrations />
    </vs-tab>
    <!--<vs-tab icon="monetization_on" label="Comissão">
      <MyComission />
    </vs-tab>
    <vs-tab v-if="comissionSquad" icon="group" label="Comissão da Equipe">
      <MyComissionSquad />
    </vs-tab>-->
    <vs-tab icon="dashboard" label="Vencimentos no Mês">
      <InstallmentsMonth />
    </vs-tab>
  </vs-tabs>
</template>

<script>
import MyPreRegistrations from "../Registration/Tab.MyPreRegistrations.vue"
//import MyComission from "../Registration/Tab.MyComission.vue"
// MyComissionSquad from "../Registration/Tab.MyComissionSquad.vue"
import InstallmentsMonth from "../Registration/Tab.MyInstallmentsMonth.vue"
import { getLoginDataFromStorage } from '../../helpers'

export default {
  components:{
    MyPreRegistrations,
    //MyComission,
    //MyComissionSquad,
    InstallmentsMonth
  },
  data(){
    return{
      userData:"",
      comissionSquad: false
    }
  },
  created(){
    this.userData = getLoginDataFromStorage();

    const profileSpecial = this.userData.profiles.find(element => element == "CoordenadorVend" || element == "SupervisorVenda");

    if(profileSpecial) {
      this.comissionSquad = true;
    } else {
      this.comissionSquad = false;
    }
  },
}
</script>

<style>
.vs-table-text{
  padding:10px;
  border-bottom: 1px solid var(--secundary)
}
</style>
